import { enhancedT } from './enhancedT';
import { i18nInstance as i18n } from './i18n';

export const i18nInstance = { ...i18n, t: enhancedT };
